import { FC } from "react";

import { AddIcon, MinusIcon } from "@chakra-ui/icons";
import { Box, Flex } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

type TExpandHeader = {
  isOpen: boolean;
};

const ExpandHeader: FC<TExpandHeader> = ({ isOpen }) => {
  const { t } = useTranslation();

  return (
    <Flex align="center" justify="space-between" bg="grey.light" width="100%" height="3.125rem" px="1rem">
      <Box>{t("order-add_new_recipient")}</Box>
      <Box bg="red.lead" color="white" width="1.625rem" height="1.625rem" borderRadius="100%">
        {isOpen ? <MinusIcon boxSize="0.75rem" /> : <AddIcon boxSize="0.75rem" />}
      </Box>
    </Flex>
  );
};
export default ExpandHeader;
